<template>
    <div class="wrapper">
      <b-row>
        <b-col>
          <b-card header="Affiliate Code Statistics">
            <div class="filter-bar ui basic segment grid">
                <div class="ui form">
                    <div class="inline field">
                        <label>Search for:</label>
                        <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, bookmaker">
                        <button class="ui primary button" @click="doFilter">Go</button>
                        <button class="ui button" @click="resetFilter">Reset</button>
                        <button class="ui  button right" @click="onsiteCheck">Onsite check</button>
                    </div>
                </div>
            </div>
            <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <button class="btn btn-info" @click="resetAffiliate(props.rowData._id)"><i class="fa fa-edit"></i> Reset</button>&nbsp;&nbsp;
                  <button class="btn btn-danger" @click="deleteAffiliate(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
                <vuetable-pagination-info ref="paginationInfo"
                ></vuetable-pagination-info>
                <vuetable-pagination ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import collect from 'collect.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      affcodes: [],
      affCode: '',
      affDescription: '',
      affBookmaker: 0,
      bookmakers: [],
      moreParams: {},
      filterText: '',

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'affcode',
          title: 'Affiliate Code',
          sortField: 'affcode'
        },
        {
          name: 'bookmaker',
          title: 'Bookmaker',
          sortField: 'bookmaker',
          callback: 'getBookmakerNameByCode'
        },
        {
          name: 'onsite',
          title: 'Onsite',
          sortField: 'onsite',
          callback: 'formatOnSite',
          dataClass: 'text-center'
        },
        {
          name: 'description',
          title: 'Description'
        },
        {
          name: 'created_at',
          title: 'First request',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: 'updated_at',
          title: 'Last request',
          sortField: 'updated_at',
          callback: 'formatDate'
        },
        {
          name: 'requests_per_referrer',
          title: 'Referrers',
          callback: 'formatReferrers'
        },
        {
          name: 'requests',
          title: 'Requests',
          sortField: 'requests'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['apiKey'])
  },
  methods: {
    formatReferrers (value) {
      let referrers = '<ul style="list-style-type: none">'
      for (const [key, val] of Object.entries(value)) {
        referrers += '<li>'
        referrers += `<strong>${this.decodeKey(key)}</strong> : ${val}`
        referrers += '</li>'
      }
      referrers += '</ul>'
      return referrers
    },
    decodeKey (key) {
      return key.replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u0024', '$').replace('\\\\', '\\')
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    getBookmakerNameByCode (value) {
      let bookmaker = collect(this.bookmakers)
      bookmaker = bookmaker.where('code', parseInt(value)).first()

      return typeof bookmaker !== 'undefined' ? bookmaker.name : '-'
    },
    getBookmakers () {
      this.$http.get(`${this.$api_url}/bookmakers`).then((bookmakers) => {
        this.bookmakers = bookmakers.data
      })
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatOnSite (value) {
      return (!value)
        ? ''
        : '<i class="fas fa-check-square"></i>'
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteAffiliate (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/statistics/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Affiliate code deleted!')
        })
      } else {
        alert('Affiliate code not deleted!')
      }
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetAffiliate (id) {
      if (confirm('Are you sure?')) {
        this.$http.patch(`${this.$api_url}/statistics/edit/${id}`).then((success) => {
          this.reloadTable()
        })
      } else {
        alert('Affiliate code not resetted!')
      }
    },
    onsiteCheck () {
      this.$http.get(`${this.$api_url}/checkActiveAffiliateCodes/${this.apiKey}`).then((data) => {
        if (data.data === 'Updated') {
          alert('Data updated')
          this.reloadTable()
        }
      })
    }
  },
  created () {
    this.api_url = this.$api_url + '/statistics'
    this.getBookmakers()
  }
}
</script>
<style scoped>
</style>
